import { useI18n } from "@/i18n";
import { Mark } from "./Logo";

/**
 * The loading screen is one of the few places the mark pulses (Design Brief §7).
 * Dots light in reading order, tracing the Z.
 */
export function FullScreenLoader() {
  const { t } = useI18n();
  return (
    <div
      role="status"
      aria-live="polite"
      style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--z-brand)" }}
    >
      <div style={{ display: "grid", justifyItems: "center", gap: 16 }}>
        <Mark size={48} pulse />
        <span style={{ color: "var(--z-muted)", fontSize: 14 }}>{t("common.loading")}</span>
      </div>
    </div>
  );
}
